(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initSlider(hero) {
    var slider = hero.querySelector('[data-hero-slider]');
    if (!slider) return;
    var slides = slider.querySelectorAll('.hero__slide');
    var dots = slider.querySelectorAll('[data-hero-dots] .hero__dot');
    if (slides.length <= 1) return;

    var current = 0;
    var delay = parseInt(hero.dataset.autoplayDelay, 10) || 5000;
    var paused = false;

    function goTo(index) {
      slides[current].classList.remove('hero__slide--active');
      if (dots[current]) dots[current].classList.remove('hero__dot--active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('hero__slide--active');
      if (dots[current]) dots[current].classList.add('hero__dot--active');
    }

    setInterval(function() {
      if (!paused) goTo(current + 1);
    }, delay);

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goTo(parseInt(this.dataset.index, 10));
      });
    });

    hero.addEventListener('mouseenter', function() { paused = true; });
    hero.addEventListener('mouseleave', function() { paused = false; });
  }

  document.querySelectorAll('.hero').forEach(function(hero) {
    if (hero.querySelector('[data-hero-slider]')) initSlider(hero);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
